import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const Welcome = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-lg);
  display: flex;
  flex-direction: column;
  height: fit-content;
  min-width: 296px;
  padding: 16px;
  position: relative;
  width: fit-content;

  ${Button.S.Button} {
    width: 100%;
  }

  ${Image.S.Image} {
    margin: 0 auto;
  }

  ${DEVICE.tablet.max} {
    display: none;
  }
`;

const WelcomeDescription = styled(Typography)`
  color: var(--color-accent-secondary-default);
  font-size: 14px;
  line-height: 24px;
  margin: 4px 0 16px;
`;

export { Welcome, WelcomeDescription };
